import { render, staticRenderFns } from "./Counseling.vue?vue&type=template&id=c57990d2&scoped=true&"
import script from "./Counseling.vue?vue&type=script&lang=js&"
export * from "./Counseling.vue?vue&type=script&lang=js&"
import style0 from "./Counseling.vue?vue&type=style&index=0&id=c57990d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c57990d2",
  null
  
)

export default component.exports